import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, ContentChild, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HatCardComponent } from '../../cards/hat-card/hat-card.component';
import { AbstractRowComponent } from '../abstract-row-component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[app-row-element]',
  styleUrls: ['./row-element.component.scss'],
  templateUrl: './row-element.component.html',
  imports: [CommonModule, MatButtonModule, MatCheckboxModule, MatIconModule, MatTooltipModule, HatCardComponent],
})
export class RowElementComponent extends AbstractRowComponent implements AfterViewInit {
  @ViewChild('_checkbox') public _checkbox: HTMLElement;
  @Input() public actionColumnFlag = true;
  @Output() public afterRowFocusedEvent = new EventEmitter<string>();
  @ContentChild('cardFive') public cardFive: unknown;
  @Output() public cardFiveEditEvent = new EventEmitter<void>();
  @Input() public cardFiveEditLabel;
  @ContentChild('cardFour') public cardFour: unknown;
  @Output() public cardFourEditEvent = new EventEmitter<void>();
  @Input() public cardFourEditLabel;
  @ContentChild('cardOne') public cardOne: unknown;
  @Output() public cardOneEditEvent = new EventEmitter<void>();
  @Input() public cardOneEditLabel: string;
  @Input() public cardOneHatDisabledFlag = false;
  @Input() public cardOneHatHighlightEnabledFlag = false;
  @Input() public cardOneHatLabel: string;
  @Input() public cardOneHatStyle:
    | 'accent'
    | 'accent-border'
    | 'customer-area'
    | 'patch'
    | 'primary'
    | 'primary-border'
    | 'warn'
    | undefined;
  @Input() public cardOneHatWidth: 'auto' | 'fixed';
  @Input() public cardOneSecondHatDisabledFlag = false;
  @Input() public cardOneSecondHatHighlightEnabledFlag = false;
  @Input() public cardOneSecondHatLabel: string;
  @Input() public cardOneSecondHatStyle:
    | 'accent'
    | 'accent-border'
    | 'customer-area'
    | 'patch'
    | 'primary'
    | 'primary-border'
    | 'warn'
    | undefined;
  @Input() public cardOneSecondHatWidth: 'auto' | 'fixed';
  @ContentChild('cardSix') public cardSix: unknown;
  @Output() public cardSixEditEvent = new EventEmitter<void>();
  @Input() public cardSixEditLabel;
  @ContentChild('cardThree') public cardThree: unknown;
  @Output() public cardThreeEditEvent = new EventEmitter<void>();
  @Input() public cardThreeEditLabel;
  @ContentChild('cardTwo') public cardTwo: unknown;
  @Output() public cardTwoEditEvent = new EventEmitter<void>();
  @Input() public cardTwoEditLabel;
  @Input() public checkableRowFlag: boolean | undefined = true;

  /**
   * Whether the row reserves the checkbox cell, regardless of whether this particular row can be checked.
   * Defaults to checkableRowFlag: a list whose rows are never checkable has no such column at all. A list where
   * only some rows are — payments, where the Stripe ones cannot be picked — must set it, or the rows without a
   * checkbox lose the cell and every following column shifts by one.
   */
  @Input() public checkboxColumnFlag: boolean | undefined;
  @Input() public checkedRow: boolean;
  @Input() public clickableRow: boolean | undefined = true;
  @Input() public columnFiveGtXsVisibleFlag = false;
  @Input() public columnFourGtXsVisibleFlag = false;
  @Input() public columnFourXsVisibleFlag = false;
  @Input() public columnThreeGtXsVisibleFlag = false;
  @Input() public columnThreeXsVisibleFlag = false;
  @Input() public columnTwoGtXsVisibleFlag = false;
  @Input() public columnTwoXsVisibleFlag = false;
  // If true, action buttons will replace (float over) the last column.
  // To work nicely only one column width could be dynamic in the table.
  @Input() public hoverActionButtons = false;
  @Output() public toggleSelectionEvent = new EventEmitter<void>();

  public editCardFive(): void {
    this.cardFiveEditEvent.emit();
  }

  public editCardFour(): void {
    this.cardFourEditEvent.emit();
  }

  public editCardOne(): void {
    this.cardOneEditEvent.emit();
  }

  public editCardSix(): void {
    this.cardSixEditEvent.emit();
  }

  public editCardThree(): void {
    this.cardThreeEditEvent.emit();
  }

  public editCardTwo(): void {
    this.cardTwoEditEvent.emit();
  }

  public focusinCheckboxHandler(): void {
    this._afterFocusedRow();
  }

  public focusRow(): void {
    if (this.checkableRowFlag) {
      this._checkbox.focus();
    } else {
      this._elementRef.nativeElement.focus();
    }
  }

  public ngAfterViewInit(): void {
    this.addEventOnTouchMove();
  }

  public toggleSelection(): void {
    this.toggleSelectionEvent.emit();
  }
}
